import React from 'react';
import { FaInbox } from 'react-icons/fa';
import './EmptyState.css';

/**
 * Enhanced EmptyState component with icon, title, description and action button.
 * Maintains backward compatibility with 'message' prop.
 */
const EmptyState = ({
  title,
  description,
  message,
  icon,
  actionLabel,
  onAction,
  actionDisabled = false
}) => {
  // Use message as description if description is not provided
  const displayDescription = description || message;

  return (
    <div
      className="empty-state-container"
      role="status"
      aria-live="polite"
    >
      <div className="empty-state-icon" aria-hidden="true">
        {icon || <FaInbox />}
      </div>

      {title && <h3 className="empty-state-title">{title}</h3>}

      {displayDescription && (
        <p className="empty-state-description">{displayDescription}</p>
      )}

      {actionLabel && onAction && (
        <button
          className="empty-state-action"
          onClick={onAction}
          disabled={actionDisabled}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
